import { jsx as _jsx } from "react/jsx-runtime";
import { ScreenSize, useScreenSize } from "../../core/util/MediaQueries";
import { FlexContainer } from "../../core/components/FlexContainer";
export const Contact3DSectionsContainer = (props) => {
    const screenSize = useScreenSize();
    const { children, padding } = props;
    if (screenSize === ScreenSize.Large) {
        return _jsx(FlexContainer, { flex: '1', gap: padding, children: children });
    }
    else {
        return children;
    }
};
//# sourceMappingURL=Contact3DSectionsContainer.js.map